import type { ReactNode } from 'react';

/**
 * Layout neutral para pantallas de auth (login, MFA, forgot password, etc.).
 *
 * NO renderiza branding/logo — cada pantalla decide qué mostrar dentro de su Card.
 * Esto evita que un default genérico (`/default-logo.svg`) aparezca cuando el
 * tenant aún no carga su branding. Cuando exista branding per-tenant resuelto
 * pre-login (vía dominio del email o tenant slug en URL), reactivar el logo
 * dentro de cada pantalla con condicional `branding.hasCustom`.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-muted/30 text-foreground p-4">
            {children}
        </div>
    );
}
